import React from 'react'

export default function Loading() {
    const overlayStyle = {
        position: "fixed",      
        top: 0,
        left: 0,
        width: "100vw",         
        height: "100vh",        
        backgroundColor: "rgba(0, 0, 0, 0.5)", 
        backdropFilter: "blur(1px)",           
        display: "flex",        
        justifyContent: "center",
        alignItems: "center",
        zIndex: "99999999",     
        pointerEvents: "all",
    }

    const imageStyle = {
        width: "80px",         
        height: "auto"
    }

    return (
        <div className='loading-overlay' style={overlayStyle}>
            <img 
                src='https://res.cloudinary.com/dwjnxcjwp/image/upload/v1768043365/loading_x2skuf.gif' 
                className='img-fluid' 
                style={imageStyle} 
                alt='Loading...' 
            />
        </div>
    )
}